import { Component, OnInit } from "@angular/core";
import { HttpService2 } from "src/app/services/Automation/http/http.service_smsReport";
import { SmsMain_Rep } from "src/classes/Automation/sms_mainreport";
import { User } from "src/classes/Automation/UserApp";
import { SetTemplateValid } from "src/classes/Automation/TemplatesSave";
import { TokenValid } from "src/classes/Automation/TokenValid";
import { RepDates } from "src/classes/Automation/RepDates";
import { BalanceGetting } from "src/classes/Automation/balance";
import { HttpService1 } from "src/app/services/Automation/http/http.service_smsAppointment";
import { formatDate } from "@angular/common";
import { DynamicDialogService } from "src/app/services/Customer/dynamic-dialog/dynamic-dialog.service";
import { ChildreportComponent } from "../childreport/childreport.component";
import { NGXLogger } from "ngx-logger";
import * as moment from "moment";

@Component({
    selector: "app-reportssms",
    templateUrl: "./reportssms.component.html",
    styleUrls: ["./reportssms.component.css"],
    providers: [HttpService2],
})
export class ReportssmsComponent implements OnInit {
    user: User = new User();
    repdates: RepDates = new RepDates();
    tokenvalid: TokenValid = new TokenValid();
    receivetokenvalid: TokenValid = new TokenValid();
    receivedsettemplatevalid: SetTemplateValid = new SetTemplateValid();

    isReportsLoading: boolean = false;
    smsmain_reps: SmsMain_Rep[];

    dateFrom: string | Date;
    dateTo: string | Date;
    maxDate: Date = new Date();
    selectedMethod: string = "הכל";

    daysRange: number = 0;
    smsCount: number = 0;
    loadedSmsCount: number = 0;
    startFromReport: number = 0;

    showData: { id: number, name: string }[] = [
        {
            id: 0,
            name: "הכל",
        },
        {
            id: 1,
            name: "נשלח",
        },
        {
            id: 2,
            name: "נכשל",
        },
    ];

    constructor(
        private httpService2: HttpService2,
        private httpService1: HttpService1,
        private dynamicDialogService: DynamicDialogService,
        private logger: NGXLogger
    ) { }

    ngOnInit(): void {
        this.user.useremail = sessionStorage.getItem("email");

        this.dateTo = new Date();
        this.dateFrom = new Date();
        this.dateFrom.setDate(this.dateFrom.getDate() - 7);

        this.maxDate = new Date();

        this.getReports();

        this.httpService1.getDataBalance(this.user)
            .subscribe((res: BalanceGetting) => {
                this.smsCount = Number(res.qsms);
            }, error => {
                console.log(error);
                this.logger.error("user: " + sessionStorage.getItem("email") + ", component: " + this.constructor.name + ", error: " + error.message);
            });
    }

    getReports(): void {
        this.isReportsLoading = true;

        let [startDate, endDate]: (string | Date)[] = [this.dateFrom, this.dateTo];

        if (typeof startDate == "string") {
            startDate = moment(startDate, "DD/MM/YYYY").toDate();
        }
        if (typeof endDate == "string") {
            endDate = moment(endDate, "DD/MM/YYYY").toDate();
        }

        if ((startDate as Date).getTime() > (endDate as Date).getTime()) {
            [startDate, endDate] = [endDate, startDate];
        }

        this.repdates.smsdatefrom = formatDate(startDate, "yyyy/MM/dd HH:mm", "en_US");
        this.repdates.smsdateto = formatDate(endDate, "yyyy/MM/dd HH:mm", "en_US");

        this.httpService2.getReportMain(this.user, this.repdates)
            .subscribe((result: SmsMain_Rep[]) => {
                this.smsmain_reps = result.filter((report: SmsMain_Rep) => this.selectedMethod != "הכל" ? report.status == this.selectedMethod : true);

                this.loadedSmsCount = 0;
                this.smsmain_reps.forEach((report: SmsMain_Rep) => this.loadedSmsCount += report.quantity);
                this.startFromReport = 0;
                this.daysRange = Math.ceil(((endDate as Date).getTime() - (startDate as Date).getTime()) / (1000 * 3600 * 24));
                this.isReportsLoading = false;
            }, error => {
                this.isReportsLoading = false;
                console.log(error);
                this.logger.error("user: " + sessionStorage.getItem("email") + ", component: " + this.constructor.name + ", error: ", error.message);
            });

    }

    refreshFilters(): void {
        this.selectedMethod = "הכל";

        this.dateTo = new Date();
        this.dateFrom = new Date();
        this.dateFrom.setDate(this.dateFrom.getDate() - 7);

        this.maxDate = new Date();

        this.getReports();
    }

    openReport(report: SmsMain_Rep): void {
        this.dynamicDialogService.openDialog(ChildreportComponent, {
            data: { report },
            styleClass: "modal modal_purpose_reports",
            closeOnEscape: false,
            showHeader: false
        });
    }
}
